<template>
  <div class="modal_wrap system ic_commonModal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">통신사 선택</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table" data-columns="">
              <label v-for="(item, index) in telecomInfo" :key="index"
                ><input
                  type="radio"
                  name="telecom"
                  :value="index"
                  v-model="selectedTelecom"
                /><span>{{ item.telecomVal }} </span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close(false)">
              닫기
            </button>
            <button class="btn2" @click="close(true)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonthModal',
  props: {
    show: Boolean,
    month: String,
  },
  data() {
    return {
      telecomInfo: [
        {
          telecomId: 'SKT',
          telecomVal: 'SKT',
        },
        {
          telecomId: 'KT',
          telecomVal: 'KT',
        },
        {
          telecomId: 'LGU+',
          telecomVal: 'LGU+',
        },
        {
          telecomId: '알뜰폰(SKT망)',
          telecomVal: '알뜰폰(SKT망)',
        },
        {
          telecomId: '알뜰폰(KT망)',
          telecomVal: '알뜰폰(KT망)',
        },
        {
          telecomId: '알뜰폰(U+망)',
          telecomVal: '알뜰폰(U+망)',
        },
      ],
      selectedTelecom: 0,
    };
  },
  computed: {},
  methods: {
    close(dataType) {
      this.$emit(
        'close',
        dataType,
        this.telecomInfo[this.selectedTelecom].telecomVal,
      );
    },
  },
};
</script>
